<script setup>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faArrowLeft } from '@digitalpa/pro-solid-svg-icons'
import TranslationProvider from '@/provider/translations.js'

library.add(faArrowLeft)
</script>

<template>
  <button
    class="btn btn-outline-secondary"
    :title="TranslationProvider.getTrans('app.torna_alla_lista')"
  >
    <font-awesome-icon icon="fa-arrow-left" />
    {{ TranslationProvider.getTrans('app.torna_alla_lista') }}
  </button>
</template>

<style scoped>
.fa-arrow-left {
  width: 0.9rem;
}
</style>
